import { defineMessages } from "react-intl";

export const messages = defineMessages({
  published: {
    id: "Sd0Ppm",
    defaultMessage: "Published on {date}",
    description: "product publication date",
  },
  unpublished: {
    id: "qpQ0uB",
    defaultMessage: "Unpublished",
    description: "product publication date",
  },
  willBePublished: {
    id: "r0hgpM",
    defaultMessage: "Becomes published on {date}",
    description: "product publication date",
  },
});

export const columnsMessages = defineMessages({
  availability: {
    id: "+VEhV8",
    defaultMessage: "Availability",
    description: "product channels",
  },
  price: {
    id: "b810WJ",
    defaultMessage: "Price",
    description: "product price",
  },
  type: {
    id: "k+HcTv",
    defaultMessage: "Type",
    description: "product type",
  },
  updatedAt: {
    id: "kVTWtR",
    defaultMessage: "Last updated",
    description: "product updated at",
  },
});
